export function getJsonData() {
    return {
        "data": [
            {
                "request": "Show me the analysis of the reviews for the last 5 days",
                "response": {
                    "answerText": "Here is the analysis of the reviews for the last 5 days. The first plot shows the count of tickets per day as reported by the users. The second plot shows the overall count of tickets in each issue category.",
                    "plots": {
                        "plot1": {
                            "type": "line",
                            "x": ["2018-01-01 00:00:00", "2018-01-02 00:00:00", "2018-01-03 00:00:00", "2018-01-04 00:00:00", "2018-01-05 00:00:00"],
                            "y": [1, 2, 3, 4, 5],
                            "xlabel": "date_time",
                            "ylabel": "count",
                            "legend": "UPI Issues",
                            "title": "No. of tickets vs day"
                        },
                        "plot2": {
                            "type": "line",
                            "x": ["2018-01-01 00:00:00", "2018-01-02 00:00:00", "2018-01-03 00:00:00", "2018-01-04 00:00:00", "2018-01-05 00:00:00"],
                            "y": [1, 2, 3, 4, 5],
                            "xlabel": "date_time",
                            "ylabel": "count",
                            "legend": "Transaction Failure",
                            "title": "No. of tickets vs day"
                        },
                        "plot3": {
                            "type": "bar",
                            "x": ["UPI Issues", "Transaction Failure", "Others"],
                            "y": [10, 20, 30, 40],
                            "xlabel": "Issue",
                            "ylabel": "count",
                            "legend": "Issue count",
                            "title": "Issue count vs type"
                        }
                    }
                }
            },
            {
                "request": "Show me the analysis of the reviews for the last 5 days",
                "response": {
                    "answerText": "Here is the analysis of the reviews for the last 5 days. The first plot shows the count of tickets per day as reported by the users. The second plot shows the overall count of tickets in each issue category.",
                    "plots": {
                        "plot1": {
                            "type": "line",
                            "x": ["2018-01-01 00:00:00", "2018-01-02 00:00:00", "2018-01-03 00:00:00", "2018-01-04 00:00:00", "2018-01-05 00:00:00"],
                            "y": [1, 2, 3, 4, 5],
                            "xlabel": "date_time",
                            "ylabel": "count",
                            "legend": "UPI Issues",
                            "title": "No. of tickets vs day"
                        },
                        "plot2": {
                            "type": "line",
                            "x": ["2018-01-01 00:00:00", "2018-01-02 00:00:00", "2018-01-03 00:00:00", "2018-01-04 00:00:00", "2018-01-05 00:00:00"],
                            "y": [1, 2, 3, 4, 5],
                            "xlabel": "date_time",
                            "ylabel": "count",
                            "legend": "Transaction Failure",
                            "title": "No. of tickets vs day"
                        },
                        "plot3": {
                            "type": "bar",
                            "x": ["UPI Issues", "Transaction Failure", "Others"],
                            "y": [10, 20, 30, 40],
                            "xlabel": "Issue",
                            "ylabel": "count",
                            "legend": "Issue count",
                            "title": "Issue count vs type"
                        }
                    }
                }
            }
        ]
    };
}

// export function getResponse() {
//     return {
//         "data":data[3]
//     }
// }

let index = 0;

export function getResponse() {
    const responseData = {
        "data": data[index]
    };
    
    // Increment index for the next call
    index = (index + 1) % data.length;

    return responseData;
}

const data = [
    {
      "answerText": "Hi there! During the period from April 17th to April 19th, there were several UI-related issues reported by users.\n Here's a summary:\n\nTicket ID: 136737- Inconsistent button behavior on payment confirmation screen. Reported by 5 users on 19th Apr, 2024.\nTicket ID: 57291 - UI disappear's and close the application. Reported by 2 users in Google Play Store on 18th Apr, 2024.",
      "plots": []
    },
    {
      "answerText": "Based on the query results, the most common issue types reported in the last 4 days include: Payment Processing Issues, Recharges and Bill Issues, User Interface and Experience Issues. The plot shows the overall count of tickets in each issue category.",
      "plots": [
        {
          "type": "bar",
          "x": ["Payment Processing Issues", "Recharges and Bill Issues", "User Interface and Experience Issues", "Others"],
          "y": [10, 7, 3, 8], // Realistic y values
          "xlabel": "Issue",
          "ylabel": "count",
          "legend": "Issue count",
          "title": "Issue count vs type"
        }
      ]
    },
    {
      "answerText": "From the query results, we can see that on April 19, 2024, there were 5 unresolved tickets, on April 18, 2024, there were 4 unresolved tickets, and on April 17, 2024, there were also 4 unresolved tickets, on April 16, 2024, there were 3 unresolved tickets. This distribution indicates that there may have been a spike in unresolved tickets on April 19, 2024, which could be due to various reasons such as a system outage, a high volume of incoming tickets, or a lack of resources to address the tickets in a timely manner. The plot shows the count of tickets per day as reported by the users.",
      "plots": [
        {
          "type": "line",
          "x": ["2024-04-16", "2024-04-17", "2024-04-18", "2024-04-19"],
          "y": [5, 4, 4, 9], // Realistic y values
          "xlabel": "date_time",
          "ylabel": "count",
          "legend": "Unresolved issues",
          "title": "No. of open tickets vs day"
	}
        ]
    },
    {
      "answerText": "Here is the analysis of the tickets for the last 5 days. The first plot shows the count of tickets per day as reported by the users. The second plot shows the overall count of tickets in each issue category.",
      "plots": [
        {
          "type": "line",
          "x": ["2024-04-15", "2024-04-16", "2024-04-17", "2024-04-18", "2024-04-19"],
          "y": [20, 8, 11, 2, 30], // Realistic y values
          "xlabel": "date_time",
          "ylabel": "count",
          "legend": "Payment Issues",
          "title": "No. of tickets vs day"
        },
        {
          "type": "line",
          "x": ["2024-04-15", "2024-04-16", "2024-04-17", "2024-04-18", "2024-04-19"],
          "y": [5, 3, 8, 15, 7], // Realistic y values
          "xlabel": "date_time",
          "ylabel": "count",
          "legend": "User Interface Issues",
          "title": "No. of tickets vs day"
        },
        {
          "type": "bar",
          "x": ["Payment Issues", "Recharges and Bill Issues", "Others"],
          "y": [71, 38, 66], // Realistic y values
          "xlabel": "Issue",
          "ylabel": "count",
          "title": "Issue count vs type"
        }
      ]
    }
  ];
